import { prisma } from "database";
import type { JWT } from "next-auth/jwt";

const updateUserSession = async (session: any, token: JWT) => {
  if (session) {
    // @TODO: Note, that `session` can be any arbitrary object, remember to validate it! using zod!
    token.user = { ...token.user, ...session.user };
  } else {
    try {
      const user = await prisma.user.findUnique({
        where: { id: token.sub || token.user?.id },
        select: {
          image: true,
          roles: { include: { role: true } },
        },
      });

      if (user) {
        token.user = { ...token.user, ...user } as any;
      }
    } catch (error) {
      // TODO: Handle error when refetch or refresh the user session
      console.log(
        "🚀 ~ file: updateUserSession.ts:19 ~ updateUserSession ~ error:",
        error
      );
    }
  }
};

export default updateUserSession;
